import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=76050f3c&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style1 from "./setting.vue?vue&type=style&index=1&id=76050f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76050f3c",
  null
  
)

export default component.exports